import Grid from '@mui/material/GridLegacy'
import Link from 'next/link'
import React, { Fragment } from 'react'
import PageTitle from '../Reusables/PageTitle'
import styles from './galleryImage.module.css';
import PolishedCard from 'modules/PolishedCard/components/PolishedCard'

export default function HomeGalleryImages({ images }) {
    return (
        <div className="mobile-p-1">
            <PageTitle sx={{ color: '#616467' }} component="h3" className="text-center uppercase m-0">Gallery</PageTitle>

            <Link href="/gallery">
                <Grid spacing={1} container>
                    {images?.map(gallery_image => (
                        <Fragment key={gallery_image.gallery_image_id}>
                            <Grid
                                className={styles.gallery_images}
                                item
                                xs={6}
                                md={3}
                                lg={2.4}
                            >

                                <PolishedCard
                                    image={gallery_image}
                                    imageSrc='image'
                                    imageAlt='title'
                                    imageKey='gallery_image_id'
                                    imageTitle='title'
                                    imageProps={{
                                        fill: true,
                                        sizes: "(max-width: 900px) 50vw, 33vw",
                                        style: {
                                            objectFit: 'cover'
                                        }
                                    }}
                                    showTitle={false}
                                />
                                {/* <Card 
                                    sx={{
                                        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                                        paddingBottom:'15%',
                                        zIndex:0,
                                    }} 
                                    className="position-relative"
                                >

                                        <Image 
                                            fill
                                            src={gallery_image.image}
                                            sizes="(max-width: 900px) 50vw, 33vw"
                                            alt={gallery_image.title}
                                            style={{
                                                objectFit: 'cover'
                                            }}
                                        />

                                        <CardActions style={{bottom: 0}} className="position-absolute mt-2 pb-0 justify-center align-items-center w-100 bg-primary background-grey">
                                            <P className="text-center grey" sx={{fontSize:16, fontWeight:'500'}}>
                                                {gallery_image.title}
                                            </P>
                                        </CardActions>
                                    </Card> */}
                            </Grid>
                        </Fragment>
                    ))}
                </Grid>
            </Link>
        </div>
    )
}
